import { FormName } from '@topconagriculture/feed-types';

import { Premix } from '../../entities/premixes/premixes.types';

export type LoadMixerGroup = {
  groupId: string;
  targetWeight: number;
  headCount?: number;
  groupDescription: string;
  feedingTime?: string;
};

export type LoadMixerIngredient = {
  ingredientId: number;
  targetWeight: number;
};

export type LoadMixer = {
  loadNo: number;
  loadPartNo: number;
  feedingNo: number;
  rationId: string;
  groups: LoadMixerGroup[];
  totalTargetWeight: number;
  totalHeadCount: number;
  ingredients: LoadMixerIngredient[];
  rationDescription: string;
  isPremix: boolean;
  density: number;
  uuid: string;
  daysOnRation: number;
};

export type LoadMixerPremix = {
  rationId: string;
  ingredientId: string;
  groupId: string;
  usedInRationIds?: number[];
  usedInFeedingPeriodIds?: string[];
  totalDailyRequirement: number;
  totalScheduledAmount: number;
  redWarning?: boolean;
  orangeWarning?: boolean;
};

export interface FeedingInScheduling {
  feedingPeriodId: string;
  actualWeight: number;
  dryWeight: number;
  perc: number;
  actualWeightStr: string;
  dryWeightStr: string;
  percStr: string;
}

export interface SchedulePremixPayload {
  premix: Premix;
  formName: FormName;
}

export interface FeedingGroupRow {
  feedingNo: number;
  groupId: string;
}

export interface DraggableFeeding {
  feedingId: string;
  newPosition: number;
}

export interface LoadListPosition {
  loadUUID: string;
  after?: boolean;
  groupId?: string;
}

export enum DataTransferMethods {
  BLUETOOTH = 'bluetooth',
  USB = 'usb',
  WIFI = 'dl',
  CL55 = 'cl55',
  FEEDING_SYSTEM = 'fs',
}
